import { EnterpriseLinkButton } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { useGenerateContractContext } from '../context/GenerateContractProvider';

// TODO: add confirmation dialog before user leaves page
export const CancelButton = () => {
    const { customerId, reservationId } = useGenerateContractContext();

    if (customerId != null) {
        return (
            <EnterpriseLinkButton
                size="medium"
                to="Customer/$id/Contracting"
                params={{ id: customerId }}
                variant="tertiary"
            >
                {lt('Cancel')}
            </EnterpriseLinkButton>
        );
    }

    if (reservationId != null) {
        return (
            <EnterpriseLinkButton
                size="medium"
                to="Reservation/Detail/$reservationId/Contracts"
                params={{ reservationId }}
                variant="tertiary"
            >
                {lt('Cancel')}
            </EnterpriseLinkButton>
        );
    }

    return null;
};
